import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import { location } from 'common/svg/icons';
import './index.css';

const Location = location;

export default class LocationButton extends PureComponent {
  static displayname = 'LocationButton';

  static propTypes = {
    onClick: func,
  };

  static defaultProps = {
    onClick: () => null,
  };

  render() {
    const { onClick } = this.props;
    return (
      <button className="location-button" type="button" onClick={onClick}>
        <Location />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/LocationButton/index.js